// Type = progress or monitoring

export default function StatusLabel({ isFinish = false, type = 'progress', isRemoved = false, isArchived = false, textMonitoring = "Novembro 2025", isLate = false}) {
  const classProgress = (isRemoved || isArchived) ? "status-trash" : !isFinish ? `status-progress` : `status-completed`
  const textProgress = isArchived ? "Arquivado" : isRemoved ? "Excluído" : !isFinish ? `Em andamento` : `Concluído`
  const isMonitoring = type === 'monitoring'

  return (
    <>
      <div className={`status-label ${isMonitoring ? 'status-label__monitoring' : ''} ${classProgress} ${isMonitoring ? isLate ? 'status-late' : 'status-pending' : ''}`}>
        {
          !isMonitoring ? (
            <span>{textProgress}</span>
          ) : <span>Monitoramento{textMonitoring ? ` • ${textMonitoring}` : ''}</span>
        }
      </div>
    </>
  )
}